export const englishCrmMessages = {
  resources: {
    projects: {
      name: "Project |||| Projects",
      fields: {
        name: "Project",
        category: "Category",
        structure_type: "Structure",
        country: "Country",
        region: "Region",
        city: "City",
        phase: "Phase",
        budget_amount: "Budget",
        funding: "Funding",
        start_date: "Start of works",
        end_date: "End of works",
        score: "Score",
        source_published_at: "Source",
        phase_contradiction: "Conflicting stage",
        last_news_at: "Source",
      },
      hide_other: "Hide “Other”",
      amount: {
        title: "Amount",
        min: "At least",
        include_unknown: "Keep projects without an amount",
        estimate:
          "Estimate in your account currency at the latest known rate; the source gives the amount in its own currency",
      },
      map: {
        view: "Display",
        view_list: "List",
        view_map: "Map",
        label: "Map of projects",
        loading: "Loading projects…",
        placed:
          "%{smart_count} project on the map |||| %{smart_count} projects on the map",
        unplaced:
          "%{smart_count} project without a country, not on the map |||| %{smart_count} projects without a country, not on the map",
        anchored:
          "%{smart_count} project without a town, on its country marker |||| %{smart_count} projects without a town, on their country marker",
        country_anchor:
          "%{country} · town unknown, %{smart_count} project |||| %{country} · town unknown, %{smart_count} projects",
        limited: "Limited to the %{limit} best-scored projects",
        city_position: "Position of the town, not of the site",
        legend_show: "Show the legend details",
        legend_hide: "Hide the legend details",
        same_city:
          "%{smart_count} project at this place |||| %{smart_count} projects at this place",
        empty:
          "No project in this selection has a placed town. Towns come from GeoNames, dropped in the “Imports” screen.",
      },
      list_header: {
        count: "%{smart_count} project |||| %{smart_count} projects",
        show_list: "Switch to list view to browse them all",
        hide_other: "Without “Other”",
        min_score: "Score ≥ %{value}",
        min_eur: "Amount ≥ €%{value}M",
        min_eur_or_unknown: "Amount ≥ €%{value}M or unknown",
        max_eur: "Amount ≤ €%{value}M",
        created_after: "Detected since %{date}",
        created_before: "Detected before %{date}",
        news_after: "News since %{date}",
        to_specify: "To be specified",
        other: "Other filter",
        more: "More actions",
        remove: "Remove filter %{label}",
      },
      country_search: "Search a country",
      country_none: "No country",
      country_all: "All countries (%{count})",
      country_less: "Fewer countries",
      categories: {
        water: "Water",
        tunnels_rail: "Tunnels and rail",
        bridges_parking: "Bridges and car parks",
        buildings: "Large buildings",
        other: "Other",
      },
      phases: {
        concept: "Concept",
        feasibility_study: "Feasibility study",
        design: "Design",
        tender: "Tender",
        awarded: "Awarded",
        pre_construction: "Pre-construction",
        construction: "Construction",
        completed: "Completed",
      },
      roles: {
        client_project_owner: "Client / Project owner",
        developer: "Developer",
        main_contractor: "Main contractor",
        general_contractor: "General contractor",
        epc_contractor: "EPC contractor",
        civil_contractor: "Civil contractor",
        waterproofing_contractor: "Waterproofing contractor",
        engineering_company: "Engineering company",
        architect: "Architect",
        design_consultant: "Design consultant",
        waterproofing_consultant: "Waterproofing consultant",
        concrete_consultant: "Concrete consultant",
        project_management_company: "Project management company",
        local_distributor_or_supplier: "Local distributor or supplier",
        funder: "Funder",
      },
      methods: {
        extracted: "Quoted from the source",
        inferred: "Deduced by AI, no quote in the source",
        entered: "Entered by a user",
      },
      sections: {
        facts: "Project facts",
        companies: "Companies and roles",
        sources: "Sources",
        sources_count: "Sources (%{smart_count})",
      },
      to_specify: "to specify",
      original_name: "Name in the source: %{name}",
      score: {
        title: "ETT score",
        not_scored: "Score not computed yet.",
        out_of: "out of 100",
        ai_note:
          "Summary and criteria marked AI: assessed by AI from the sources (confidence %{confidence}%).",
        provisional: "Provisional weights, to be tuned.",
        to_specify:
          "To specify: the record gives no country, or neither city nor company. Score capped until a more precise source arrives; the criteria give %{uncapped}.",
        capped:
          "Score capped because works are under way or the amount is small: the criteria add up to %{uncapped}.",
        capped_no_city:
          "Score capped because the record gives no city: we do not know where to look. The criteria add up to %{uncapped}.",
        points: "%{points} / %{weight}",
        by_ai: "AI",
        stamp: "Rules + AI",
        stamp_title:
          "Score computed by rules and an AI assessment of the sources",
        details: "Criteria breakdown",
        unknown: "Information missing: no points.",
        amount: "Amount of about %{amount}",
        surface: "Surface quoted in the source: %{surface} m²",
        need: "Estimated product need: %{litres} litres",
        criteria: {
          water_contact: "Water contact, pressure",
          waterproofing_need: "Waterproofing need",
          structure_type: "Type of structure",
          size: "Project size",
          phase: "Project stage",
          membrane_replacement: "Membrane replacement",
          access_difficulty: "Access difficulty",
        },
      },
      companies_show_more:
        "Show the other company |||| Show the %{smart_count} other companies",
      no_companies: "No company identified in the sources.",
      duplicates: {
        title: "Duplicates to review",
        intro:
          "These records may describe the same project. Neither the rules nor the AI could decide.",
        empty: "No pair waiting.",
        forbidden: "This screen is reserved for the imports manager.",
        button:
          "%{smart_count} duplicate to review |||| %{smart_count} duplicates to review",
        same: "Same project: merge",
        different: "Different projects",
        rule_note: "Names %{similarity}% alike: %{reason}.",
        ai_note: "AI opinion (confidence %{confidence}%): %{note}",
        document: "%{date} · %{title}",
        merge_recorded:
          "Decision saved. The two records will be merged at the next matching run.",
        rejected: "Decision saved. This pair will not be suggested again.",
      },
      company_projects: "%{smart_count} project |||| %{smart_count} projects",
      switchboard: {
        label: "Switchboard:",
        found: { site: "read on its website", manual: "entered" },
        contact: "Company switchboard:",
        help: "The company's main number, free: ask for the person by name.",
      },
      site: {
        found: {
          notice: "read in a notice",
          wikidata: "found through Wikidata",
          search: "found by Aubeon",
          manual: "entered",
          unknown: "unknown origin",
        },
        on: "on %{date}",
        source: "source",
        report: {
          action: "Report an error",
          title: "Report this website as wrong",
          help: "It is removed from the company for everyone, will not be suggested again, and the data owner is notified. The next contact search will look for another website.",
          note: "What is wrong (optional), e.g. website of a namesake",
          confirm: "Remove this website",
          cancel: "Cancel",
          done: "Website removed, thank you: the data owner has been notified.",
        },
      },
      contacts: {
        title: "Contacts",
        copy_email: "Copy email",
        copied: "Address copied",
        copy_failed: "Copy failed",
        sent_prompt: "Message sent to %{name}?",
        sent_yes: "Yes",
        sent_later: "Later",
        relation: {
          contacted: "Contacted",
          in_touch: "In touch",
          specifier: "Specifier won",
          set_specifier: "Specifier won",
          unset_specifier: "Remove “specifier”",
        },
        search:
          "Find contacts · %{smart_count} credit per email |||| Find contacts · %{smart_count} credits per email",
        search_again:
          "Search again · %{smart_count} credit per email |||| Search again · %{smart_count} credits per email",
        pending_help:
          "Depending on how hard the contacts are to find, the search can take up to 3 minutes. You can leave this page and come back: the contacts found will be shown here.",
        pending: "Search in progress…",
        requested:
          "Search requested: contacts will appear here within a few minutes.",
        empty: "No contact for this project.",
        show_more:
          "Show the other contact |||| Show the %{smart_count} other contacts",
        last_search:
          "Last search on %{date}: %{smart_count} contact added. |||| Last search on %{date}: %{smart_count} contacts added.",
        last_error: "The search of %{date} failed.",
        guessed: {
          valid: "(inferred address, confirmed by the mail server)",
          catch_all:
            "(inferred from the company's address format, the server accepts any address)",
          unknown: "(inferred from the company's address format, not verified)",
        },
        probable: {
          label: "Probable",
          button: "Probable email · free",
          button_help:
            "Address built from the company's usual format. Its server cannot verify it: use with care.",
          warning_title: "Probable address, not verified",
          warning_company:
            "It is built from the format read on other addresses of the company.",
          warning_common:
            "It is built from the most common format (first.last): no address of this company is known.",
          warning_server:
            "The company's mail server does not say whether this address exists. A message sent to a wrong address may be lost without any error in return.",
          warning_advice:
            'For a verified address, use "Verified email": the credit is only charged if our providers find one.',
          warning_silence: "Don't warn me again",
          warning_show: "Show the address",
          help: "Inferred address that nobody can verify: the company's mail server does not reveal which addresses exist. Free, it does not count as an email found.",
          unverifiable:
            "Unverifiable: the company's mail server does not reveal which addresses exist.",
          company: "Format read on other addresses of the company.",
          common:
            "Most common format (first.last), no address of the company known.",
          providers: "Our providers also know this address.",
        },
        provided: {
          valid: "(address found through our providers, verified)",
          catch_all:
            "(address found through our providers, the server accepts any address)",
        },
        email_status: {
          verified: "confirmed by its mail server on %{date}",
          published: "address written on this page, read on %{date}",
        },
        tools: {
          both: "Place in the chain, report an error",
          place: "Place in the chain",
          report: "Report an error",
        },
        report: {
          action: "Report an error · free",
          phone: "Phone",
          title: "What is wrong?",
          reasons: {
            unrelated: "Contact unrelated to this project",
            left: "Has left the company",
            email: "Wrong email",
            phone: "Wrong number",
            linkedin: "Wrong LinkedIn",
          },
          effect_unrelated:
            "The person is removed from this project for your team, and the search will not add them back.",
          effect_left:
            "The person is removed from all your team's projects, and the search will not add them back.",
          effect_email:
            "The address is removed for your team and will not be offered to you again. Credits already spent are not refunded.",
          effect_phone:
            "The number is removed for your team and will not be offered to you again. Credits already spent are not refunded.",
          effect_linkedin:
            "The profile is removed for your team and will not be offered to you again.",
          note: "Details (optional), for example: message bounced",
          confirm: "Report",
          cancel: "Cancel",
          done_unrelated:
            "Contact removed from the project, thank you: the data manager has been notified.",
          done_left:
            "Contact removed from your projects, thank you: the data manager has been notified.",
          done_email:
            "Address removed, thank you: the data manager has been notified.",
          done_phone:
            "Number removed, thank you: the data manager has been notified.",
          done_linkedin:
            "Profile removed, thank you: the data manager has been notified.",
        },
        notes: {
          no_email: "No address found.",
          no_mobile: "No mobile found.",
          no_linkedin: "No LinkedIn profile found.",
          known_email: "Address already known.",
          missing_name:
            "First name, last name or company missing: search not possible.",
          suppressed: "Contact on the opt-out list.",
          company_suppressed: "Company on the opt-out list.",
          unavailable: "Search unavailable for now, no credit charged.",
          budget_sites:
            "Monthly AI cap reached: company websites were not read.",
          budget_chain:
            "Monthly AI cap reached: the decision chain was not proposed.",
          suppressed_count: "%{count} contact(s) left out: opt-out list.",
          missed:
            "Already searched without result less than %{count} days ago.",
          no_company:
            "No company known for this project, even after a web search: get alerted when the radar finds one.",
          probable_missed:
            "Our providers have no verified address: nothing is charged. The probable address remains the best lead.",
          probable_known:
            "Our providers also know the probable address, without being able to verify it: nothing is charged.",
          landline_only:
            "Only a landline was found, kept on the record: nothing is charged.",
        },
        lookup: {
          fresh: "found on %{date}",
          button: {
            email:
              "Email · %{smart_count} credit |||| Email · %{smart_count} credits",
            email_verified:
              "Verified email · %{smart_count} credit |||| Verified email · %{smart_count} credits",
            mobile:
              "Mobile · %{smart_count} credit |||| Mobile · %{smart_count} credits",
            linkedin: "LinkedIn · free",
          },
          email:
            "Find email · %{smart_count} credit |||| Find email · %{smart_count} credits",
          email_verified:
            "Our providers look for a verified address or one other than the probable address · %{smart_count} credit, charged only then |||| Our providers look for a verified address or one other than the probable address · %{smart_count} credits, charged only then",
          linkedin: "Find LinkedIn · free",
          mobile:
            "Find mobile · %{smart_count} credit |||| Find mobile · %{smart_count} credits",
          running: "%{kind}: search in progress…",
          short:
            "Not enough credits (%{kinds}): at least %{price} credit(s) needed, %{available} available. Ask an administrator.",
          joins_contacts: "Once found, the person joins the project contacts.",
          pending: "Searching…",
          requested:
            "Search requested, result in a minute or two. You can leave this page and come back: the result will be shown here.",
          kinds: {
            email: "Email",
            linkedin: "LinkedIn",
            mobile: "Mobile",
          },
          result: "%{kind}, search of %{date}: %{note}",
          result_short: "search of %{date}: %{note}",
          found: "found",
        },
        team: {
          title: "Company teams",
          fold: "Find more people",
          short:
            "Not enough credits: %{price} credits needed, %{available} available. Ask an administrator.",
          company_title: "Company team",
          help: "People working at the company in purchasing, projects, engineering, on site and in management, from their public profile, found through our providers. %{smart_count} credit, charged only if at least one person is added. |||| People working at the company in purchasing, projects, engineering, on site and in management, from their public profile, found through our providers. %{smart_count} credits, charged only if at least one person is added.",
          button:
            "Find the team · %{smart_count} credit |||| Find the team · %{smart_count} credits",
          pending: "Searching the team…",
          requested:
            "Team search requested, result in a few minutes. You can leave this page and come back: the people found will be shown here.",
          result:
            "Search of %{date}: %{smart_count} person added. |||| Search of %{date}: %{smart_count} people added.",
          members:
            "Company teams: %{smart_count} person without email or place in the chain |||| Company teams: %{smart_count} people without email or place in the chain",
          from_company:
            'People found join the company contacts and the project "%{project}".',
          members_help:
            "Name, job title and profile found through our providers. A person joins the contact list once they have an email or a place in the chain.",
          filter: "Filter by job title or name (compras, proyecto…)",
          moved_email:
            "%{name}: email found, this person has moved to the project contacts.",
          moved_phone:
            "%{name}: phone found, this person has moved to the project contacts.",
          moved_other: "%{name} has moved to the project contacts.",
          see: "↑ Show",
          joined_email: "New · email found on %{date}",
          joined_phone: "New · phone found on %{date}",
        },
        source: "Source, read on %{date}",
        linkedin: "LinkedIn profile",
        linkedin_found: "found by Aubeon on %{date}, profile not read",
        linkedin_provider: "found through our providers",
        credits:
          "The search is free; only each person's e-mail obtained for the first time on this project costs %{price} credit, however it was found. A person's email or mobile searches are charged only if the data is found.",
        credits_short:
          "Not enough credits: a search needs at least %{price} credit, %{available} available. Ask an administrator for more.",
        on_project: {
          label: "On this project",
          help: "Their job title mentions “%{word}”: they work on this project, not just at the company.",
        },
        funder: {
          label: "Funder — information",
          help: "Finances the project without choosing products: useful to learn its progress and who carries it out, not to specify.",
        },
        decision: {
          title: "Decision chain",
          help: "Suggested by the tool from each company's role on the project and each person's job. Correct it if needed: your correction prevails.",
          empty: "Nobody has a place in the chain yet.",
          label: "Place in the chain",
          roles: {
            prescribes: "Specifies",
            validates: "Approves",
            buys: "Buys",
            applies: "Applies",
            none: "No place",
          },
          inferred: "suggested by the tool, confidence %{confidence}%",
          short_confidence: " · %{confidence}%",
          to_check: " · to check",
          place_of: "Place of %{name} in the decision chain",
          manual: "corrected on %{date}",
          not_assessed: "not assessed yet",
          saved: "Place in the chain saved",
        },
        kinds: { person: "Person", service: "Department" },
      },
      references: {
        title: "Reference sites",
        intro:
          "Sites where ETT was used, which the assistant can cite as proof in a first message. It cites only these, and only when the structure type matches.",
        empty:
          "No reference site on file, so messages cite no proof. They are more convincing with 2 or 3 references.",
        empty_ask:
          "No reference site on file, so messages cite no proof. Ask an administrator to add 2 or 3.",
        count:
          "%{smart_count} reference site |||| %{smart_count} reference sites",
        add: "Add a reference",
        remove: "Remove the reference",
        read_only: "Only team administrators add or remove references.",
        fields: {
          title: "Site",
          structure_type: "Structure type",
          country: "Country",
          year: "Year",
          replaced: "What ETT replaced",
          result: "Observed result",
          source_url: "Link (optional)",
        },
        placeholders: {
          title: "e.g. … wastewater treatment plant",
          structure_type: "e.g. Basin, reservoir, tunnel, car park…",
          country: "e.g. France",
          year: "e.g. 2024",
          replaced: "e.g. Basin waterproofing membrane",
          result: "e.g. No leakage after two years",
          source_url: "https://…",
        },
      },
      assistant: {
        title: "Assistant",
        intro:
          "Written by AI from the sourced information of this record only. Review before use: nothing is sent.",
        brief: "Analyse the record",
        summary: "The project",
        why_relevant: "Fit for ETT",
        who_first: "Who to contact first",
        draft_title: "First message",
        recipient: "Recipient",
        no_recipient:
          "Search for the record's contacts first to draft a message.",
        formats: { email: "E-mail", linkedin: "LinkedIn message" },
        language: "Language",
        languages: {
          auto: "Language of the project's country",
          fr: "French",
          en: "English",
        },
        draft: "Draft",
        subject: "Subject",
        body: "Message",
        copy: "Copy",
        copied: "Text copied",
        linkedin_help:
          "Paste it into LinkedIn from your own account: the tool never connects to it.",
        connection_note: "Connection request note",
        characters: "%{count} / %{max} characters",
        linkedin_body: "Message, once the connection is accepted",
        connection_sent:
          "Connection request sent to %{name}? The message below will be kept on the deal, with a reminder on %{date}.",
        connection_replaces: "Replaces the next action: %{action}",
        connection_yes: "Yes, remind me of the message",
        connection_follow: "Follow this project and remind me of the message",
        connection_request: "Connection request",
        connection_reminder_saved: "Reminder set for %{date}",
        hook: "Hook: “%{hook}” (%{origin})",
        no_hook:
          "No reliable hook found: the message opens on the project. Add one if you know the person.",
        hook_origins: {
          project: "from the project",
          person: "from the person",
          company: "from their company",
          reference: "from your references",
        },
        from_base: "radar database",
        signals: "Information used",
        inferred: "inferred",
        assessment: "assessment by the tool",
        source: "source dated %{date}",
        working: "Drafting…",
      },
      export: {
        file: "radar-projects",
        xlsx: "Excel (.xlsx)",
        csv: "CSV",
        score: "Score",
        name: "Project",
        category: "Category",
        structure_type: "Structure type",
        phase: "Phase",
        country: "Country",
        region: "Region",
        city: "City",
        owners: "Owners",
        amount: "Amount",
        currency: "Currency",
        amount_eur: "Amount in euros (estimate, ECB rate)",
        funding: "Funding",
        start_date: "Start",
        end_date: "End",
        source: "Source",
        source_url: "Source link",
        published_at: "Published on",
        last_news_at: "Latest news on",
        detected_at: "Detected on",
        aegyra_id: "AEGYRA ID",
        link: "Radar record",
        deals_file: "radar-deals",
        deal_name: "Deal",
        stage: "Stage",
        deal_company: "Deal company",
        manager: "Manager",
        next_action: "Next action",
        next_action_type: "Next action type",
        next_action_date: "Due on",
        last_activity: "Last exchange",
        deal_amount: "Deal amount",
        project_name: "Followed project",
        created_at: "Created on",
        updated_at: "Updated on",
        deal_link: "Deal in the radar",
      },
      export_log: {
        title: "Export log",
        menu: "Export log",
        intro:
          "Every file exported from the radar leaves a line here: who, when, which list, how many rows and with which filters. The log cannot be edited.",
        empty: "No export yet.",
        created_at: "Date",
        author: "Author",
        resource: "List",
        format: "Format",
        rows: "Rows",
        filters: "Filters",
        no_filter: "none",
        resources: {
          projects: "Projects",
          deals: "Deals",
          contacts: "Contacts",
          companies: "Companies",
        },
      },
      health: {
        title: "Radar health",
        menu: "Radar health",
        intro:
          "What the radar did each night, the sources that no longer bring anything and the path of contact searches. Figures come from the run log and the steps of each search. Only you can see this page.",
        forbidden: "This page is reserved for the imports owner.",
        nights_title: "The last %{count} nights",
        nights_empty:
          "No run recorded yet: the log starts with the next night.",
        night: "Night",
        commands: "Commands",
        contact_requests: "Contact searches",
        llm_cost: "AI",
        provider_cost: "Search and providers",
        more_errors: "and %{count} more error(s)",
        failed_runs: "%{count} failed run(s)",
        counters: {
          projects: "projects compared",
          confirmed: "merges confirmed by a user",
          merged: "merged",
          new_doubts: "new doubts",
          stale: "pairs removed",
          merge: "merged",
          reject: "rejected",
          keep: "left to a user",
          postponed: "postponed",
          extracted: "extracted",
          not_relevant: "not relevant",
          translated: "translated",
          original_name: "with their original name",
          english_name: "renamed in English",
          missing: "no answer",
          searched: "searched",
          completed: "completed",
          facts: "facts found",
          recomputed: "scores recomputed",
          changed: "changed",
          assessed: "assessed by AI",
          email_retries: "addresses retried",
          error: "errors",
        },
        status: { ok: "complete", partial: "incomplete", error: "failed" },
        sources_title: "Sources to check",
        sources_intro:
          "Failing, keeping nothing for a week although they kept documents before, bringing nothing new, or having kept nothing over the period.",
        sources_empty: "Every source brings and keeps documents.",
        source: "Source",
        reason: "Finding",
        inserted: "New",
        kept_before: "Kept before",
        kept_recent: "Kept over 7 days",
        reasons: {
          failing: "Failing",
          collapsed: "Keeps nothing anymore",
          silent: "Nothing new",
          never_kept: "Nothing kept over the period",
        },
        funnel_title: "Contact searches of the last %{count} days",
        funnel_intro:
          "Projects searched, then those with at least one company, a company with its website, a person, a reliable e-mail (read on a page or confirmed by the server) and a person placed in the chain with a reliable e-mail. Source: the first one that brought the project.",
        funnel_empty: "No contact search recorded over the period.",
        by_source: "By source",
        by_country: "By country",
        country: "Country",
        projects: "Projects",
        steps: {
          companies: "Company",
          site: "Website",
          people: "Person",
          email: "Reliable e-mail",
          placed_email: "Placed + e-mail",
        },
        outcomes_title: "Outcome of each step (%{count} days)",
        outcomes_intro:
          "How often each step succeeded or stopped, and why the people and profiles read were dropped.",
        rejected: "Dropped",
        step_names: {
          buyer_notice: "TED notice contact",
          companies: "Companies searched on the web (project without one)",
          worldbank_team: "World Bank team",
          site: "Company websites",
          site_people: "People read on websites",
          linkedin: "LinkedIn profiles",
          project_people: "Managers searched on the web",
          email: "Address of each person",
          chain: "Decision chain",
          lookup: "Per-person lookups",
          summary: "Projects searched",
        },
        outcomes: {
          found: "found",
          none: "nothing",
          not_found: "not found",
          error: "error",
          skipped: "not run",
          already_read: "already read",
          already_searched: "already searched",
          budget: "budget reached",
          no_page: "no readable page",
          proposed: "proposed",
          confirmed: "confirmed by the server",
          published: "published on a page",
          catch_all: "server accepts everything",
          unknown: "server does not answer",
          temporary: "server unavailable",
          refused: "refused by the server",
          retry: "to retry",
          check_limit: "check limit",
          not_checked: "not checked",
          no_site: "no website",
          no_mail_domain: "website without mail",
          suppressed: "opt-out list",
          stock: "found in stock",
          provider: "found at the provider",
        },
        rejections: {
          not_a_person: "not a person",
          name_not_on_page: "name not on the page",
          title_not_on_page: "title not on the page",
          not_target_function: "role outside construction",
          email_dropped: "e-mail removed",
          phone_dropped: "phone removed",
          not_a_profile: "not a profile",
          foreign_country: "other country",
          not_at_company: "other company",
          suppressed: "opt-out list",
          over_site_limit: "over the per-site limit",
          over_company_limit: "over the per-company limit",
        },
      },
      imports: {
        title: "Imports",
        menu: "Imports",
        intro:
          "Some sources refuse robots but publish their data for free reuse. Their file is downloaded by hand (every month for ISVZ, every quarter for Kohesio, twice a year for GeoNames) and dropped here; the radar processes it at the next collection. A reminder reaches you when a file is due. Only you can see this page.",
        forbidden: "This page is reserved for the imports manager.",
        isvz_title: "Czech Republic: public procurement register (ISVZ)",
        step_download:
          "From the 6th of the month, download the previous month's “VZ” file (VZ-MM-YYYY.zip, about 180 MB) from the ISVZ open data page. The other files (DNS, SON, SK…) are not used.",
        open_data: "ISVZ open data",
        step_choose:
          "Choose it below. Your browser reads it (about a minute), keeps works contracts above the EU threshold, below it and in simplified procedure, and sends only those.",
        step_night:
          "The next night's collection keeps recent contracts dealing with water, bridges, tunnels, rail or car parks and turns them into projects. The report arrives in your alerts and in the e-mail summary.",
        choose: "Choose the month's file",
        privacy: "No person's name is sent: only buyers and winning companies.",
        reading:
          "Reading the file: %{contracts} contracts read, %{kept} works contracts kept",
        sending: "Sending: %{sent} contracts out of %{total}",
        sent: "%{total} contracts for %{period} sent. They will be processed at the next night's collection.",
        failed: "The import failed: %{error}",
        bad_name:
          "“%{name}” is not an ISVZ VZ file (expected name: VZ-MM-YYYY.zip).",
        no_json: "the ZIP contains no JSON file.",
        nothing_kept: "no works contract kept in this file.",
        history: "Imports",
        empty: "No import yet.",
        period: "Source · period",
        deposited: "Dropped on",
        records: "Rows sent",
        status: "Status",
        outcome: "Outcome",
        result: "%{kept} documents kept, %{stale} contracts too old",
        sources: {
          isvz: "ISVZ",
          geonames: "GeoNames",
          kohesio: "Kohesio",
          jpeia: "Impact assessments (Japan)",
          mirt: "MIRT Overzicht (Netherlands)",
          vib: "Verkehrsinvestitionsbericht (Germany)",
          rahmenplan: "ÖBB-Rahmenplan (Austria)",
          kpk: "Krajowy Program Kolejowy (Poland)",
          ntp: "Nasjonal transportplan (Norway)",
          budjetti: "Finnish state budget (Väylävirasto)",
          standbericht: "Swiss rail expansion programmes (FOT)",
          sfdi: "Czech transport infrastructure fund budget (SFDI)",
        },
        kohesio_title: "European Union: cohesion policy operations (Kohesio)",
        kohesio_step_download:
          "In January, April, July and October, from the 6th, download the per-country CSV exports of the latest batch (one file per country, named COUNTRY-pp21-27-YYYYMMDD.csv, about 660 MB in all) from the Kohesio data page. The Kohesio server refuses the radar's address: this download cannot be automatic.",
        kohesio_open: "Kohesio data",
        kohesio_step_choose:
          "Choose them all together below (CSV versions, not Excel). Your browser reads them (a few minutes) and only sends operations of at least €10M.",
        kohesio_step_night:
          "The next night's collection keeps ongoing operations started less than three years ago in water, guided transport or a named structure, then turns them into projects. The report arrives in the alerts.",
        kohesio_choose: "Choose the per-country exports",
        kohesio_license:
          "Kohesio data, European Commission, CC BY 4.0 licence. Beneficiaries are organisations.",
        kohesio_reading:
          "Reading files: %{operations} operations read, %{kept} of at least €10M",
        kohesio_sending: "Sending: %{sent} operations out of %{total}",
        kohesio_sent:
          "%{total} operations from the %{batch} batch sent (quarter %{period}). They will be processed at the next night's collection.",
        kohesio_bad_name:
          "“%{name}” is not a Kohesio per-country export (expected name: COUNTRY-pp21-27-YYYYMMDD.csv).",
        kohesio_mixed:
          "the chosen files come from different batches: take every country from the same batch.",
        kohesio_nothing: "no operation of at least €10M in these files.",
        kohesio_result: "%{kept} operations kept out of %{records} sent",
        jpeia_title:
          "Japan: environmental impact assessments of major works (Ministry of the Environment)",
        jpeia_step_read:
          "In January, April, July and October, from the 6th, click “Read impact assessments”. Your browser reads the list of cases from the last five years, then the summary of dams, hydropower plants, railways and major roads (one request per second, about a minute). The site refuses the radar's address: this reading cannot be automatic.",
        jpeia_step_night:
          "The next night's collection turns them into projects, at the study stage. The report arrives in the alerts.",
        jpeia_open: "Impact assessment site",
        jpeia_choose: "Read impact assessments",
        jpeia_license:
          "Environmental Impact Assessment Information Network, Ministry of the Environment of Japan, PDL 1.0 licence.",
        jpeia_reading_list:
          "Reading the list: %{read} cases read, %{kept} kept",
        jpeia_reading_details: "Reading summaries: %{details} of %{kept}",
        jpeia_sending: "Sending: %{sent} cases of %{total}",
        jpeia_sent:
          "%{total} cases sent (quarter %{period}). They will be processed by the next night's collection.",
        jpeia_nothing: "no case kept in the list.",
        jpeia_refused:
          "the site refused the reading (%{error}). Try again later; if it still refuses, report it.",
        jpeia_result: "%{kept} cases kept out of %{records} sent",
        mirt_result: "%{kept} project sheets kept out of %{records} read",
        vib_result: "%{kept} projects kept out of %{records} read",
        rahmenplan_result: "%{kept} projects kept out of %{records} lines read",
        kpk_result: "%{kept} projects kept out of %{records} lines read",
        ntp_result:
          "%{kept} projects kept by the filter out of %{records} read",
        budjetti_result:
          "%{kept} projects kept by the filter out of %{records} read",
        standbericht_result:
          "%{kept} projects kept by the filter out of %{records} read",
        sfdi_result:
          "%{kept} projects kept by the filter out of %{records} read",
        geonames_title: "GeoNames cities: placing projects on the map",
        geonames_step_download:
          "In January and July, from the 6th, download cities1000.zip (towns over 1,000 inhabitants, about 10 MB) from the GeoNames files page. The server refuses robots: this download cannot be automated.",
        geonames_open: "GeoNames files",
        geonames_step_choose:
          "Choose it below. Your browser reads it (a few seconds) and sends the towns, their position and their names in Latin script.",
        geonames_step_night:
          "The next night, the list of towns is replaced and each project is placed on its town, never at the centre of its country. The report arrives in your alerts.",
        geonames_choose: "Choose cities1000.zip",
        groups_title: "Proposed mail groups",
        groups_intro:
          "Each month, the radar picks out contractor names that recur across several projects and suggests a mail domain for them. An accepted group is used from the next contact search: its subsidiaries without a website are checked on that domain. Nothing is used without your approval; a rejected word is never suggested again.",
        groups_empty: "No pending proposal.",
        groups_counts: "%{companies} company(ies), %{projects} projects",
        groups_method_company_site: "Website of one of these companies",
        groups_method_wikidata: "Official website read in Wikidata",
        groups_source: "source",
        groups_accept: "Accept",
        groups_reject: "Reject",
        groups_accepted: "Accepted groups",
        groups_withdraw: "withdraw",
        geonames_license: "GeoNames data, CC BY 4.0 licence.",
        geonames_reading: "Reading the file: %{cities} towns read",
        geonames_sending: "Sending: %{sent} towns out of %{total}",
        geonames_sent:
          "%{total} towns sent (half-year %{period}). They will be stored at the next night's collection.",
        geonames_bad_name:
          "“%{name}” is not the expected file (expected name: cities1000.zip).",
        geonames_no_txt: "the ZIP contains no text file.",
        geonames_too_few: "too few towns read in this file.",
        geonames_result:
          "%{places} towns stored; %{placed} projects placed out of %{projects} with a town",
        statuses: {
          uploading: "Upload interrupted",
          pending: "Waiting for the night",
          running: "Running",
          done: "Processed",
          error: "Error",
        },
      },
      daily_picks: {
        title: "Today's top 10",
        computed_today: "Picked last night",
        computed_on: "Picked on %{date}",
        not_computed:
          "The selection is made every night: it will show here tomorrow morning.",
        empty:
          "Nothing new on your projects today: no phase moving forward, no contractor or contact found.",
        to_specify: "To be specified",
        dismiss: "Dismiss",
        dismiss_help: "Stop suggesting it, unless its phase moves forward",
        source: "Open the source",
        reasons: {
          new: "New project",
          phase: "Moved to %{phase} on %{date}",
          contractor: "Contractor known: %{value}",
          owner: "Project owner known: %{value}",
          budget: "Budget: %{value}",
          budget_unknown: "Budget known",
          contact: "Reachable contact: %{value}",
          contact_unnamed: "Reachable contact found",
        },
      },
      dashboard: {
        map_title: "Map of projects",
        map_legend_shade: "More projects",
        map_legend_deal: "Deal followed",
        map_hint: "Pick a country to see its figures.",
        map_projects: "%{smart_count} project |||| %{smart_count} projects",
        map_high: "%{count} at %{score} or more",
        map_deals:
          "%{smart_count} deal followed |||| %{smart_count} deals followed",
        map_none: "No project",
        map_open: "See the list",
        title: "Dashboard",
        greeting: "Hello %{name}",
        intro:
          "Projects in your scope excluding the “other” category, and open deals. Amounts are converted to your account currency at the ECB rate: they are estimates.",
        projects: "Projects detected",
        projects_short: "Projects",
        new_week: "New in the last 7 days",
        high_score: "Score of %{score} or more",
        high_score_short: "Score ≥ %{score}",
        countries: "Countries",
        value: "Known project value",
        value_short: "Known value",
        value_note:
          "Estimate over %{smart_count} project with an amount, ECB rate of %{date} |||| Estimate over %{smart_count} projects with an amount, ECB rate of %{date}",
        follow_up: "Sales follow-up",
        deals_active: "Open deals",
        deals_overdue: "Overdue actions",
        deals_without_action: "Deals without a next action",
        deals_idle: "No activity for %{days} days",
        top_projects: "High-score projects",
        new_projects: "New this week",
        no_new: "No new project in the last 7 days.",
        see_all: "See all",
        estimate: "Estimate",
        countries_ranking: "Countries ranking",
        countries_all: "See all %{count} countries",
        countries_less: "See the top ones only",
        country: "Country",
      },
      teaser: {
        offers: "See the plans",
        sources:
          "Every piece of information on this project comes from a verifiable source: tender notice, council decision, press. With a subscription, you see the sources and their links.",
        list_hidden:
          "%{count} project in the database matches these filters outside your access |||| %{count} projects in the database match these filters outside your access",
        list_hidden_high: ", %{count} scored 80 or more",
        countries_hint: "Number of projects in the whole database",
        contacts:
          "With a subscription, find this project's decision makers and their contact details.",
        assistant_quota: "5 analyses per week with your access.",
        assistant_limit:
          "Your 5 analyses for this week are used. With a subscription, analyse all your projects.",
        questions_counts:
          "Ask a question in plain language: the answer gives numbers over the whole database. %{smart_count} question left this week. |||| Ask a question in plain language: the answer gives numbers over the whole database. %{smart_count} questions left this week.",
        questions_lock:
          "With a subscription, you open these projects, their companies and their contacts.",
        questions_none:
          "Your 3 questions for this week are used. With a subscription, ask as many as you need and open the projects.",
        interest_label: "Your area of interest",
        interest_placeholder: "Choose a zone or a country",
        interest_zones: "Zones",
        interest_countries: "Countries",
        interest_saved:
          "Area saved: the first selection arrives tomorrow morning",
        interest_hint:
          "Choose a zone or a country: every morning you will see here what moves in the database, and on Mondays the number of new projects of the week.",
        teasers_none:
          "Nothing moved yesterday in your area, or the first selection arrives tomorrow morning.",
        teasers_title: "Projects moving in your area",
        teasers_lock:
          "%{smart_count} project in your area moved yesterday outside your access. |||| %{smart_count} projects in your area moved yesterday outside your access.",
        bands: {
          "<10": "Under €10M",
          "10-100": "€10M to €100M",
          "100-500": "€100M to €500M",
          "500+": "Over €500M",
        },
        signals: {
          new: "New project",
          phase: "Phase moving forward",
          contractor: "Contractor known",
          owner: "Owner known",
          budget: "Budget known",
        },
      },
      help: {
        score: {
          title: "The ETT score",
          body: "From 0 to 100: how much the project needs concrete waterproofing (water contact, structure type, size, stage). Computed by rules and by AI from the sources. It is capped when the works are too advanced, the amount small or the project vague; the project page gives the details.",
        },
        evidence: {
          title: "Sourced or inferred",
          body: "“Sourced”: the value is quoted word for word in a document you can open. “Inferred”: AI drew it from the sources without an exact quote, with a confidence level; “To check” when it is low.",
        },
        amount: {
          title: "Amounts",
          body: "The source amount, in its own currency, is the reference. The “≈” line converts it into your account currency at the ECB reference rate: it is an estimate.",
        },
        amount_filter: {
          title: "Amount filter",
          body: "Compares the amount converted into euros at the ECB rate. Many projects have no amount yet: “Keep projects without an amount” avoids losing them.",
        },
        phase: {
          title: "Phases",
          body: "From earliest to latest: concept, feasibility study, design, tender, awarded, pre-construction, construction, completed. Specifying is possible until pre-construction; once the concrete is poured, it is too late. A phase never goes back, even if an older source says otherwise.",
        },
        category: {
          title: "Categories",
          body: "Water, tunnels and rail, bridges and car parks, large buildings (at least one basement, 15 storeys or €50M): the concrete structures we target. “Other” groups the projects that fit none of these; “Hide Other” removes them from the list.",
        },
        sources: {
          title: "Sources",
          body: "The document that revealed the project, and its date. “2 sources”: the radar matched several documents about the same project; the project page lists them all.",
        },
        chain: {
          title: "Decision chain",
          body: "Who gets the product chosen: who specifies it, who approves, who buys, who applies it. The tool suggests a place for each contact from their company and job title, with a confidence level; correct it if needed.",
        },
        emails: {
          title: "Email reliability",
          body: "Safe: read on a page or confirmed by the mail server. Inferred: built from the company's address format, not confirmed. Probable: built from the company's format, or first.last, when its server does not reveal which addresses exist; free, use with care. “Verified email” then asks our providers for a verified or different address, charged only if they find one.",
        },
        daily: {
          title: "Today's 10",
          body: "Every night, up to 10 projects in your scope that moved in the last 3 days: phase moving forward, contractor or contact found, budget, new project. Score of at least 60, at most 3 projects per country. “Dismiss” removes one, unless its phase moves forward.",
        },
        follow: {
          title: "Follow, watch, saved watch",
          body: "Follow this project: creates a deal in your pipeline, and you are alerted of any change. Alert me when a company is added: watches the project without a deal. Saved watch: reports new projects matching a list filter.",
        },
        partners: {
          title: "Partners",
          body: "Sharing opens the project to a partner and shows them the contacts your organisation found on it. Handing over the deal makes them responsible for it; your organisation still sees it. Nothing else of your work is visible to them.",
        },
        country_value: {
          title: "Known value",
          body: "Sum of the known amounts of the country's projects, converted at the ECB rate. Many projects have no amount: it is a minimum, not the size of the market.",
        },
      },
      watch: {
        watch: "Alert me when a company is added",
        done: "Alert on: you will be notified in your alerts",
        missing:
          "No company known yet for: %{families}. The radar rereads its sources every night.",
        active: "Alert on: %{families}",
        stop: "Stop",
        settings_link: "Settings",
        settings_title: "Companies added to watched projects",
        settings_intro:
          "From a project, “Alert me when a company is added” notifies you here, and in the email if it is on. Choose the roles you care about; they apply to all your watched projects.",
        one_family:
          "Keep at least one role. To receive nothing, stop watching the projects.",
        families: {
          owner: "Project owner",
          design: "Design",
          contractor: "Contractors",
          other: "Others",
        },
        family_roles: {
          owner: "Project owner, developer",
          design: "Engineering, architect, project management, consultants",
          contractor: "Main, general, EPC, civil and waterproofing contractors",
          other: "Funders, local distributors and suppliers",
        },
        watched:
          "%{smart_count} watched project |||| %{smart_count} watched projects",
        none: "No watched project. In the Companies block of a project: “Alert me when a company is added”.",
        since: "since %{date}",
      },
      alerts: {
        saved_search_hidden:
          "%{count} new project from the saved search “%{search}” is outside your access |||| %{count} new projects from the saved search “%{search}” are outside your access",
        weekly_teaser:
          "%{count} new project this week in your area (%{area}) |||| %{count} new projects this week in your area (%{area})",
        teaser_high: "%{count} scored 80 or more",
        teaser_tenders: "%{count} tender |||| %{count} tenders",
        title: "Alerts",
        intro:
          "Partner comments and updates, overdue actions, changes on the projects you follow, companies added to the projects you watch, new projects from your watches.",
        empty: "No alerts.",
        mark_all_read: "Mark all as read",
        new: "New",
        project_shared: "%{who} (%{org}) shared “%{project}” with you",
        project_shared_deal:
          "%{who} (%{org}) shared “%{project}” with you and handed you the deal",
        partnership_new: "%{who} (%{org}) added you as a partner",
        partnership_ended: "%{org} ended the partnership",
        partnership_left: "%{who} left the partnership",
        a_partner: "A partner",
        partner_note: "%{who} commented on “%{subject}”",
        partner_follow: "%{who} is following “%{subject}”",
        partner_stage: "%{who} moved “%{subject}” to %{stage}",
        partner_archive: "%{who} archived “%{subject}”",
        partner_update: "%{who} updated “%{subject}”",
        overdue: "Overdue action on “%{subject}”",
        project_change: "Change on “%{subject}”",
        company_arrived: "Company added to “%{subject}”",
        tab_alerts: "Alerts",
        tab_settings: "Settings",
        subscription_request: "%{who} requests a subscription",
        next_action: "%{action}, due %{date}",
        saved_search: "New project for the watch “%{search}”",
        score: "score %{score}",
        silent_source:
          "The source “%{source}” has brought nothing new since %{date}",
        source_back:
          "The paused source “%{source}” answers again (week of %{date})",
        mail_groups: "%{count} mail group(s) proposed: %{words}",
        mail_groups_body:
          "To accept or reject on the “Imports” screen; nothing is used without your approval.",
        source_back_body: "To reconnect: read its terms and robots.txt again",
        job_partial: "Run “radar %{command}” of %{date} incomplete",
        job_error: "Run “radar %{command}” of %{date} failed",
        job_more: "and %{count} more error(s)",
        source_drop:
          "The source “%{source}” brings documents but has kept none since %{date}",
        source_drop_body: "Review the filter or the source's content",
        provider_low:
          "Low %{provider} balance: %{balance} credits, below the %{threshold} threshold",
        provider_low_body:
          "Top it up in the provider's dashboard; at zero, requested e-mails and mobiles are no longer searched there.",
        import_due: "%{source} file for %{period} to drop in monthly imports",
        import_due_body:
          "The month's file is out: download it and choose it on the “Monthly imports” screen.",
        import_due_yearly: "New %{source} edition for %{period} to download",
        import_due_yearly_body_vib:
          "Look for “Verkehrsinvestitionsbericht für das Berichtsjahr %{year}” on dip.bundestag.de (printed papers, “Unterrichtung”), then have it processed on the worker with the PDF address: radar collect --source vib --file <PDF address>.",
        import_due_yearly_body_rahmenplan:
          "Look for “ÖBB-Rahmenplan %{year}” among the Nationalrat's “III” reports on parlament.gv.at, then have it processed on the worker with the dossier address: radar collect --source rahmenplan --file <dossier address>.",
        import_due_yearly_body_kpk:
          "Look for the Krajowy Program Kolejowy “Sprawozdanie z wykonania w %{year} roku” on gov.pl (programme page of the Ministry of Infrastructure), then have it processed on the worker with the attachment address: radar collect --source kpk --file <attachment address>.",
        import_due_yearly_body_budjetti:
          "On budjetti.vm.fi, open the %{year} budget proposal (“Talousarvioesitys %{year}”), then item 31.10.77 “Väyläverkon kehittäminen”, and have it processed on the worker with the address of the item page: radar collect --source budjetti --file <item page address>.",
        import_due_yearly_body_sfdi:
          "On sfdi.gov.cz (“Rozpočet SFDI” section), copy the address of the xlsx file of the appendices of the approved %{year} budget (“přílohy”), then have it processed on the worker: radar collect --source sfdi --file <file address>.",
        import_due_yearly_body_standbericht:
          "On bav.admin.ch (rail expansion page), copy the address of the “Kennzahlen %{year}” PDF in German (appendix of the “Standbericht %{year} - Eisenbahnausbauprogramme”), then have it processed on the worker: radar collect --source standbericht --file <PDF address>.",
        import_due_yearly_body_mirt:
          "Download the year's “MIRT Overzicht” PDF from mirtoverzicht.nl (Documenten section), then have it processed on the worker: radar collect --source mirt --file <file>.",
        import_done: "%{source} import for %{period} processed",
        import_done_body:
          "%{kept} documents kept out of %{records} contracts sent, %{stale} too old.",
        import_error: "%{source} import for %{period} failed",
        wrong_data: "%{who} reports an error: %{person}",
        wrong_data_body: "%{data} %{value} removed from the contact",
        wrong_site_body: "%{data} %{value} removed from the company",
        wrong_data_unrelated:
          "Unrelated to the project: removed from the project for their team",
        wrong_data_left:
          "Has left the company: removed from their team's projects",
        report_confirm: "Remove for all teams",
        report_undo: "Undo the report",
        report_confirmed: "Data removed for all teams.",
        report_undone: "Report undone: the data or contact is back.",
        report_is_confirmed: "Removed for all teams.",
        report_is_undone: "Report undone.",
        wrong_data_fields: {
          email: "Email",
          phone: "Phone",
          linkedin: "LinkedIn profile",
          website: "Website",
        },
        last_error: "Last error: %{error}",
        digest: "Receive a daily e-mail summary",
        digest_help:
          "One e-mail a day, to %{email}, with the alerts you have not read yet. Nothing is sent on days without alerts.",
        digest_on: "E-mail summary turned on",
        digest_off: "E-mail summary turned off",
        share_emails: "Get an e-mail for each shared project",
        share_emails_help:
          "When a partner shares a project with you or adds you as a partner, an e-mail goes right away to %{email}, with the project link.",
        share_emails_on: "E-mail on each share turned on",
        share_emails_off: "E-mail on each share turned off",
      },
      questions: {
        title: "Questions about the base",
        intro:
          "Ask a question in plain language about the projects you can see. Every figure comes from the base, computed with your rights; cited projects, companies, deals and people open with one click.",
        placeholder: "E.g.: how many upstream water projects in Morocco?",
        placeholder_short: "Ask a question…",
        follow_up_placeholder: "Follow-up question…",
        history: {
          title: "History",
          new: "New conversation",
          empty:
            "No conversations yet. Your questions are saved here, visible to you only.",
          today: "Today",
          yesterday: "Yesterday",
          week: "Last 7 days",
          older: "Older",
          delete: "Delete conversation",
          delete_title: "Delete this conversation?",
          delete_content:
            "It is removed from your history and its answers are erased. This cannot be undone.",
          deleted: "Conversation deleted",
          load_error: "History unavailable: %{message}",
          not_found: "This conversation no longer exists.",
          asked_on: "Answer of %{date}, figures as of that day",
          repeat: "Ask again",
          back: "Back to the conversation",
        },
        ask: "Ask",
        ask_question: "Ask a question",
        working: "Searching the base…",
        understood: "Understood as: %{interpretation}",
        discarded:
          "Written answer discarded: a figure or a name could not be found in the results of the base. Here are the results themselves.",
        results:
          "Results from the base (%{smart_count} tool) |||| Results from the base (%{smart_count} tools)",
        see_in_list: "See in the list",
        see_in_list_partial: "See in the list (partly)",
        missing_list: "Not applied in the list: %{keys}",
        watch: "Create a watch",
        watch_done: "Watch created",
        watch_saved:
          "Watch saved: new matching projects will be reported to you every night.",
        watch_saved_partial:
          "Watch saved, without these criteria a watch cannot follow: %{keys}.",
        missing_watch: "Not followed by the watch: %{keys}",
        useful: "Useful answer",
        not_useful: "Not a useful answer",
        example_1:
          "Which upstream water projects in Morocco have the best score?",
        example_2: "Which project owners come up most often in France?",
        example_3: "Which projects changed phase this week?",
        example_4: "Which deals have an overdue action?",
        tools: {
          count_projects: "Project count",
          search_projects: "Projects",
          top_companies: "Companies",
          recent_changes: "Changes",
          list_deals: "Deals",
          suggest_names: "Close names",
          find_people: "People",
        },
        filter_keys: {
          words: "words",
          any_words: "words",
          zones: "zone",
          place: "city or region",
          company: "company",
          company_role: "company role",
          min_eur: "minimum amount",
          max_eur: "maximum amount",
          min_score: "minimum score",
          created_after: "date added",
          created_before: "date added",
          news_after: "latest news date",
          to_specify: "projects to specify",
          followed: "followed projects",
        },
      },
      saved_searches: {
        title: "My watches",
        empty:
          "No watches. Filter the project list, then “Save as watch”: every night, matching new projects will be flagged here.",
        save: "Save as watch",
        dialog_intro:
          "Every night, new projects matching these criteria are flagged in your alerts, once each, among the projects you can see.",
        no_list_filter: "No list filter: set a score or an amount.",
        name: "Watch name",
        min_score: "Minimum score",
        min_budget: "Minimum amount (€M)",
        min_score_label: "score ≥ %{score}",
        min_budget_label: "≥ €%{amount}M",
        needs_criterion:
          "At least one criterion is needed, otherwise every new project would raise an alert.",
        confirm: "Save",
        saved: "Watch saved",
        delete: "Delete watch",
      },
      partners: {
        title: "Partners and territories",
        intro:
          "The distributors and installers you work with. An invited partner is free: they see the projects you share with them and the deals you hand over; they become a subscriber by taking out a plan, you cannot do it for them.",
        none: "No partner yet: invite the first one.",
        suspended: "Suspended",
        disable: "Suspend",
        enable: "Reactivate",
        remove: "Remove partnership",
        remove_title: "Remove %{name}'s partnership?",
        remove_content:
          "Their account becomes a team member's: they will see the whole database and your deals. Keep this for a data entry mistake; to cut their access, suspend them.",
        offer_locked:
          "A partner becomes a subscriber when they take out a plan: you cannot do it for them.",
        region_hint:
          "A region is compared with the project's text: assign the project if the source spells it differently.",
        admin: "Administrator",
        partner: "Partner",
        territories: "Territories",
        no_territory: "No territory: only shared projects are visible.",
        country: "Country (FR)",
        region: "Region (optional)",
        add_territory: "Add",
        assigned:
          "%{smart_count} shared project |||| %{smart_count} shared projects",
        block_title: "Partners",
        shared_with: "Can see this project",
        shared_by: "shared by %{name}",
        deal_holder: "follows the deal",
        unshare: "Stop sharing",
        choose: "Choose a partner",
        choose_many: "Share with",
        share: "Share",
        share_count: "Share |||| Share with %{smart_count} partners",
        with_deal:
          "Also hand over the deal: they become responsible for it, your organisation still sees it.",
        shared: "Project shared with %{name}.",
        shared_deal: "Project shared and deal handed over to %{name}.",
        shared_many_deal:
          "Project shared with %{name}; deal handed over to %{holder}.",
        with_deal_many:
          "Also hand the deal over to one of them: they become responsible for it, the others see the project, your organisation still sees the deal.",
        with_deal_many_held:
          "Also hand the deal over to one of them; currently followed by %{name}, it will be taken back from them.",
        deal_to: "Deal to",
        with_deal_held:
          "Also hand over the deal, now followed by %{name}: it will be taken from them.",
        transmit_deal: "hand over the deal",
        transmit_deal_held: "Take the deal from %{name} and hand it over",
        deal_transmitted: "Deal handed over to %{name}.",
        unshared: "Share removed; any deal goes back to your organisation.",
        no_partner: "No partner yet: invite one.",
        all_shared: "All your partners already see this project.",
        invite: {
          action: "Invite a new partner",
          title: "Invite a partner",
          lead: "They get an e-mail in your name, naming this project, to set their password. If they already have an account, they are added to your partners and told by e-mail.",
          lead_list:
            "They get an e-mail in your name to set their password. If they already have an account, they are added to your partners and told by e-mail. A new partner is a guest: free, they only see what you share with them.",
          locale: "Invitation language",
          locale_help:
            "Used for their e-mails and account; they can change it later. Suggested from the project's country.",
          locale_help_list:
            "Used for their e-mails and account; they can change it later.",
          submit_list: "Invite",
          done_new: "Invitation sent to %{email}.",
          done_existing:
            "%{name} already had an account: added to your partners and notified by e-mail and in their alerts.",
          already: "This person is already your partner.",
          already_pending:
            "This person is already your partner but has not opened their invitation yet: resend it from “My partners”.",
          email_failed:
            "Partner added, but the invitation e-mail was not sent. Try again later or let them know yourself.",
          resent: "Invitation sent again to %{name}.",
          resend_too_soon:
            "An invitation was sent less than 24 hours ago: try again tomorrow.",
          already_signed_in: "%{name} has already opened their account.",
          resend_failed:
            "The invitation was not sent. Try again later or let them know yourself.",
          already_member:
            "This person is already a member of your organisation.",
          not_a_partner:
            "This address belongs to an account that cannot be a partner.",
          not_authorized: "Inviting partners comes with the subscription.",
          failed: "The invitation did not go through. Try again.",
          first_name: "First name",
          last_name: "Last name",
          email: "Work email",
          submit: "Invite and share the project",
        },
      },
      install: {
        title: "Install the app",
        intro: "Aubeon on your home screen, full screen, like an app.",
        button: "Add to home screen",
        installed_title: "App installed",
        installed: "Open Aubeon from the icon on your home screen.",
        ios_step1: "Open this page in Safari.",
        ios_step2:
          "Tap the Share button (a square with an up arrow), in the “…” menu if needed.",
        ios_step3: "Choose “Add to Home Screen”, then “Add”.",
        android_step1: "Open this page in Chrome.",
        android_step2: "Tap the ⋮ menu at the top right.",
        android_step3: "Choose “Install app” or “Add to home screen”.",
        already:
          "Already added? Open Aubeon from the icon on your home screen.",
      },
      subscribers: {
        menu: "Subscribers",
        title: "Subscribers",
        intro:
          "Each side (your team or a partner organisation) and each person: offer, credits, what they cost you and their last activity. An account's cost only counts what it triggers itself; the radar's shared cost is not split. Only you can see this page.",
        desktop_only: "This screen is for desktop use.",
        search: "Name, email or organisation",
        month: "Month",
        totals: {
          accounts: "Account spend",
          unattributed: "Unattributed",
          unattributed_help:
            "Contact searches made before 27 October 2026, with no known requester.",
          common: "Radar shared cost",
          ai_left: "Left under the AI cap: %{amount}",
          airscale: "Airscale balance",
          airscale_unknown: "Airscale balance not read",
          active: "Active accounts",
          active_current_only: "current month only",
        },
        airscale_counter: {
          title: "Airscale used by the radar",
          help: "What the radar asked Airscale for this month, from its own log. The Airscale balance above is that of the whole account, which other tools also use.",
          credits: "Credits",
          cost: "Cost",
          calls: "Calls",
          calls_value: "%{found} found out of %{calls}",
          found: "Found",
          none: "No Airscale call this month.",
          operation: "Lookup",
          error: "Airscale counter unreadable.",
          operations: {
            email: "Email",
            profile: "LinkedIn profile",
            mobile: "Mobile",
            team: "Team",
          },
        },
        signals: {
          title: "To look at",
          none: "Nothing to report this month.",
          low_balance: "Low balance",
          high_spend: "Spend above %{amount}",
          inactive: "Inactive for 14 days",
          pending_request: "Pending subscription request",
          invited_long: "Invited for more than 30 days",
        },
        columns: {
          account: "Account",
          offer: "Offer",
          people: "People",
          balance: "Balance",
          credits: "Credits used",
          cost: "Spend",
          activity: "Last activity",
        },
        error: "Could not load the subscribers: %{message}",
        collapse: "Hide people",
        expand: "Show people",
        client_team: "Your team",
        never: "never",
        suspended: "suspended",
        no_rate: "Amounts in dollars: no dollar rate in the database.",
        panel: {
          close: "Close",
          offer_price: "Offer price: %{amount} per month",
          offer_price_help: "offer price, not a payment received",
          offer_countries:
            "%{smart_count} country |||| %{smart_count} countries",
          offer_zones: "%{smart_count} zone |||| %{smart_count} zones",
          no_offer: "No paid offer",
          territories: "Territories",
          world: "World licence",
          months: "Last six months",
          month: "Month",
          airscale: "Airscale",
          serper: "Web search",
          contacts_ai: "Contacts AI",
          assistant: "Project assistant",
          base: "Database questions",
          total: "Total",
          credits_spent: "Credits used",
          per_credit: "Cost per credit used",
          usage: "This month's usage",
          contact_requests: "Contact searches: %{count}, %{found} successful",
          questions: "Questions asked: %{count}",
          watches: "Watched projects: %{count}",
          open_deals: "Open deals: %{count}",
          logins: "Sign-ins: at least %{count}",
          logins_help:
            "Minimum: a session closed by signing out is no longer counted.",
          ledger: "Latest credit movements",
          no_ledger: "No movement.",
          people: "People",
          requests: "Latest contact searches",
          no_requests: "No search.",
          recent_questions: "Latest questions",
          no_questions: "No question.",
          pending_requests: "Pending subscription requests",
          pending_request: "%{label}, on %{date}",
          created_at: "Organisation created on %{date}",
          next_topup: "Next top-up: %{date}",
          no_topup: "No monthly top-up",
          invited_at: "Invited on %{date}",
          accepted_at: "Invitation accepted on %{date}",
          not_accepted: "Invitation not accepted yet",
          last_activity: "Last activity: %{date}",
          side_of: "Side: ",
          role_partner: "Partner",
          role_org_admin: "Organisation administrator",
          role_administrator: "Administrator",
          role_member: "Collaborator",
          language: "Language: %{locale}",
          currency: "Currency: %{currency}",
          suspended: "Suspended",
          resend: "Resend the invitation",
          resend_confirm: "Send %{email} a link to choose a password?",
          resend_done: "Link sent",
          collaborator: "Open the collaborator's page",
          status: "Status",
          status_pending: "Pending",
          status_done: "Done",
          status_error: "Failed",
          found: "Found",
          credits: "Credits",
          cost: "Cost",
          date: "Date",
          project: "Project",
          question: "Question",
        },
      },
      offer: {
        desktop_only:
          "Team members, partners and territories, exports and imports: on a computer.",
        title: "Plan and coverage",
        intro:
          "Your plan, what it opens to you, and what the database records by zone and country to choose your territories. To become a subscriber or change territories, request a plan below: the subscription starts once payment is received.",
        yours: "Your plan",
        team: "Team",
        team_help:
          "Team member: the whole database, the team's deals and contact searches.",
        invited: "Invited partner",
        invited_help:
          "Invited: only shared projects and transmitted deals, which they work on. No new deals and no contact searches; their territories do not count until they subscribe.",
        subscriber: "Subscribed partner",
        subscriber_help:
          "Subscribed: the whole database for their territories (countries, zones or world), their own deals and contact searches with their credits.",
        world: "World",
        change:
          "To change your plan or territories, contact your account manager.",
        choose_zone: "Add a zone",
        add_zone: "Add zone",
        estimator: "Estimate a coverage",
        estimator_help:
          "Tick zones or add countries: the total counts each country once.",
        countries: "Countries",
        projects_30d: "Projects over 30 days",
        high_score_30d: "Of which score 80+",
        projects: "In database",
        outside: "Other countries (outside zones)",
        add_country: "Add a country",
        select: "Choose a zone, a country or the world.",
        summary:
          "Your selection: %{smart_count} project recorded over 30 days in %{countries} countries, %{high} of them scoring 80 or more (%{total} in database). |||| Your selection: %{smart_count} projects recorded over 30 days in %{countries} countries, %{high} of them scoring 80 or more (%{total} in database).",
        estimate_note:
          'Database counts to date, excluding the "other" category. They depend on the connected sources: Europe is well covered by public tender notices, other countries much less so. A country without projects is not listed.',
      },
      zones: {
        "western-europe": "Western Europe",
        "northern-europe": "Northern Europe and Baltics",
        "central-eastern-europe": "Central and Eastern Europe",
        "east-africa": "East Africa",
        "southern-africa": "Southern Africa",
        "middle-east": "Middle East",
        oceania: "Oceania",
        "south-asia": "South Asia",
        "north-africa": "North Africa",
        "west-africa": "West Africa",
        "central-africa": "Central Africa",
        "central-asia": "Central Asia and Caucasus",
        "southeast-asia": "Southeast Asia",
        "east-asia": "East Asia",
        "north-america": "North America",
        "latin-america": "Latin America and Caribbean",
      },
      pricing: {
        title: "Subscription plans",
        intro:
          "The whole database for your territory, your deals and contact searches. Prices per month, no VAT charged.",
        annual: "Annual commitment",
        monthly: "Quarterly",
        per_month: "/ month",
        annual_detail: "Over 12 months: %{total} per year, −%{saving}%",
        monthly_detail: "3-month minimum, billed %{total} per quarter",
        complete: "Most complete",
        plans: {
          country: {
            name: "1 country",
            tagline: "For a national distributor.",
            scope:
              "Every project in the chosen country, with score and sources",
          },
          zone: {
            name: "1 zone",
            tagline: "To cover a region of the world.",
            scope:
              "Every project in the zone's countries, with score and sources",
          },
          world: {
            name: "World",
            tagline: "The full tool, with no territory limit.",
            scope: "Every project in the database, in every country",
          },
        },
        choose_country: "Choose a country",
        choose_zone: "Choose a zone",
        coverage:
          "%{smart_count} project over 30 days in %{countries} countries, %{high} scoring 80 or more |||| %{smart_count} projects over 30 days in %{countries} countries, %{high} scoring 80 or more",
        feature_deals: "Your own deals and their follow-up",
        feature_credits:
          "%{smart_count} contact credit per month for the whole organisation (%{email} per e-mail found, %{mobile} per mobile) |||| %{smart_count} contact credits per month for the whole organisation (%{email} per e-mail found, %{mobile} per mobile)",
        feature_assistant: "Assistant: project summary and first message",
        feature_alerts: "Alerts on the projects you follow",
        request: "Request this plan",
        sent: "Request sent: we will get back to you to activate it.",
        pending:
          "Request sent on %{date}: %{label}. We will get back to you to activate it.",
        cancel: "Cancel the request",
        team_preview:
          "Preview: this is the page partners see. Their requests go to the subscription manager.",
        footnote:
          "Project counts are today's database counts; they depend on the connected sources, still few outside Europe. No VAT charged (French VAT exemption, article 293 B of the CGI). Invited partner: free, by invitation, limited to the projects and deals transmitted to them.",
        requested: "Subscription request of %{date}: %{label}",
        accept: "Accept",
        managed_by: "Plan and territories managed by the subscription manager",
        annual_billed: "12-month commitment, billed %{total} per year",
      },
      credits: {
        title: "Credits",
        intro:
          "A credit pays for a contact detail delivered, however it was found (company website, mail server or provider): %{price} per person's e-mail obtained for the first time on a project, %{mobile} per mobile, %{team} per company team. The contact search, companies, names, job titles, LinkedIn profiles and the decision chain are free.",
        balance: "%{smart_count} credit |||| %{smart_count} credits",
        reserved: "of which %{reserved} held by searches in progress",
        gauge:
          "%{count} credit available, shared by the whole team |||| %{count} credits available, shared by the whole team",
        gauge_org:
          "%{count} credit available, shared by %{org} |||| %{count} credits available, shared by %{org}",
        gauge_low: "low balance: not enough for a mobile number",
        gauge_empty: "no credits left: ask an administrator",
        on_project:
          "Available balance: %{count} credit |||| Available balance: %{count} credits",
        amount: "Credits",
        grant: "Grant",
        remove: "Remove",
        granted: "Balance updated.",
        note: "Reason (required)",
        confirm_title:
          "Add %{smart_count} credit to %{name}? Reason: |||| Add %{smart_count} credits to %{name}? Reason:",
        confirm_remove:
          "Remove %{smart_count} credit from %{name}? Reason: |||| Remove %{smart_count} credits from %{name}? Reason:",
        movements: "Movements",
        no_movement: "No movement.",
        project: "open the project",
        side_client: "Client team",
        side_select: "Balance to show",
        members: "%{smart_count} user |||| %{smart_count} users",
        monthly_side: "%{monthly} credits each month, shared by everyone",
        pool_info:
          "One balance, shared by all users, however many they are. On the 1st of each month it receives the licence's credits; half of the unused credits carry over, up to one month's worth.",
        usage: "Team usage",
        usage_own: "My usage",
        month: "Month",
        no_usage: "No usage this month.",
        disabled: "disabled",
        movements_of: "Movements of %{name}",
        all_movements: "All movements",
        columns: {
          person: "Person",
          emails: "E-mails",
          mobiles: "Mobiles",
          teams: "Teams",
          spent: "Credits",
          share: "Share",
          total: "Total",
        },
        reasons: {
          monthly: "Monthly credits",
          expiry: "Unused credits, expired",
          plan: "Plan top-up",
          grant: "Grant",
          correction: "Correction",
          contacts: "Contact search",
          email: "People's e-mails",
          mobile: "Mobile search",
          team: "Company team",
        },
      },
      history: {
        title: "Change history",
        older: "%{smart_count} older change |||| %{smart_count} older changes",
        empty: "No change observed since the record was created.",
        changed: "%{old} → %{new}",
        added: "%{new} (new)",
        contradiction:
          "A newer source says “%{new}”; the record stays at “%{old}”, as the stage never moves back.",
      },
      published_on: "Published on %{date}",
      collected_on: "Collected on %{date}",
      published_and_collected:
        "Published on %{published} · collected on %{collected}",
      // Mention exigée par l'Open Database License (marchés de la DGCP, République dominicaine)
      odbl_notice:
        "Contains information from the database of %{publisher}, made available under the",
      // Mention exigée par la licence CC BY 4.0 de Postor Abierto (procédures de ComprasMX)
      postor_notice:
        "Data from Postor Abierto (postor.com.mx), retrieved on %{date}. %{citation}.",
      // Mention exigée par la licence PDL 1.0 du ministère japonais de l'Environnement (source et transformation)
      jpeia_notice:
        "Source: “環境影響評価情報支援ネットワーク” (環境省, assess.env.go.jp), translated and summarised by Aubeon Project.",
      // Mention exigée par les conditions d'utilisation de l'API de simap.ch
      // Mention exigée par l'Open Government Licence – Toronto (formule de la licence, gardée en anglais)
      // Disclaimer required by the City of Chicago data terms of use
      // Attribution required by the BOE reuse conditions (wording set by the licence, kept in Spanish)
      boe_notice: "Basado en datos de la",
      chicago_notice:
        "This site provides applications using data that has been modified for use from its original source, www.cityofchicago.org, the official website of the City of Chicago. The City of Chicago makes no claims as to the content, accuracy, timeliness, or completeness of any of the data provided at this site. The data provided at this site is subject to change at any time. It is understood that the data provided at this site is being used at one’s own risk.",
      toronto_notice:
        "Contains information licensed under the Open Government Licence – Toronto.",
      simap_notice:
        "This is not an official publication. The data published on www.simap.ch is authoritative.",
      last_news: "Latest news on %{date}",
      summary: {
        score: "Score",
        project: "Project",
        contact: "Reach",
        news: "Latest news",
        no_amount: "amount unknown",
        email: "email",
        phone: "phone",
        no_reachable: "No reachable contact.",
        no_contact: "No contact found.",
        see_contacts: "See contacts",
        stale: "%{date} · over 12 months: check the project is still going",
      },
      sources_count: "%{smart_count} source |||| %{smart_count} sources",
      stale_news:
        "No news since %{date}: check that the project is still going before prospecting.",
      stamps: {
        extracted: "Sourced",
        inferred: "AI inferred",
        entered: "Entered",
      },
      confidence: "confidence %{value}%",
      source_ref: "Source %{n}",
      to_check: "To check: low confidence",
      actions: {
        label: "Project actions",
        credits_short: "Not enough credits for a search",
        invited:
          "Guest offer: follow-up and contact search are for subscribers. To follow this project, ask your contact to hand over the deal.",
        see_offer: "See the offer",
      },
      company_table: {
        name: "Company",
        roles: "Roles in projects",
        countries: "Project countries",
        projects: "Projects",
        contacts: "Contacts",
        more: "+ %{count}",
      },
      panel: {
        label: "Project sheet",
        position: "%{position} of %{total}",
        previous: "Previous project (K)",
        next: "Next project (J)",
        close: "Close (Esc)",
        keys: "J / K to move between projects",
      },
    },
    partnerships: {
      mine: {
        title: "My partners",
        intro:
          "The outside people your organisation works with: you share projects and hand over deals to them. They see nothing else of your work.",
        invite: "Invite a partner",
        name: "Name",
        organisation: "Organisation",
        offer: "Plan",
        invited: "Guest",
        subscriber: "Subscriber",
        shares: "Shared projects",
        deals: "Handed-over deals",
        since: "Since",
        end: "End",
        invite_pending: "Invitation not opened, sent on %{date}",
        resend: "Resend invitation",
        resend_later: "can be resent 24 h later",
        end_title: "End the partnership with %{name}?",
        end_confirm:
          "The projects you shared will no longer be visible to them and handed-over deals return to your organisation. Contacts they found themselves stay theirs.",
        ended: "Partnership with %{name} ended.",
        empty: "No partner yet.",
        not_available: "Inviting partners comes with the subscription.",
        history: {
          toggle: "History",
          empty: "No project sent to this partner yet.",
          shared: "Sent on %{date}",
          shared_by: "Sent on %{date} by %{name}",
          sees: "sees the project",
          revoked: "share removed on %{date}",
          no_deal: "Project only, no deal handed over",
          deal: "Deal handed over: %{stage}",
          next_action: "next action on %{date}",
        },
      },
      hosts: {
        title: "Partnerships",
        intro:
          "The organisations that work with you and share projects or deals with you. You only see the part of their work they share.",
        since: "Since %{date}",
        shares:
          "%{smart_count} shared project |||| %{smart_count} shared projects",
        deals:
          "%{smart_count} handed-over deal |||| %{smart_count} handed-over deals",
        leave: "Leave this partnership",
        leave_title: "Leave the partnership with %{name}?",
        leave_confirm:
          "You will no longer see the shared projects, and handed-over deals go back to %{name}. Your notes stay on those deals, with them.",
        left: "You left the partnership with %{name}.",
        empty: "No organisation works with you yet.",
        not_partner: "This page is for an organisation's partners.",
      },
    },
    onboarding: {
      tips: {
        done: "Got it",
        progress: "{{current}} of {{total}}",
        projects: {
          score: {
            title: "The ETT score",
            body: "From 0 to 100: the higher it is, the more the project needs concrete waterproofing. Open a project to see each criterion.",
          },
          filters: {
            title: "Your territory",
            body: "Filter by country and amount; save the filter as a watch to hear about new projects.",
          },
        },
        project: {
          stamps: {
            title: "Sourced or inferred",
            body: "“Sourced”: the value is quoted word for word from a document. “Inferred”: the AI inferred it, with a confidence level.",
          },
          contacts: {
            title: "Who to contact",
            body: "Run a contact search: it is free and places each person in the decision chain. Only the e-mails and mobiles obtained use credits.",
          },
          contacts_invited: {
            title: "Who to contact",
            body: "Contacts for each project are for subscribers: see the plans to unlock them.",
          },
        },
        daily: {
          reasons: {
            title: "Why this one",
            body: "Each line says what moved: new project, phase, contractor, budget. The selection changes every night.",
          },
        },
        alerts: {
          saved: {
            title: "Your settings",
            body: "Email digest, companies on the projects you watch and saved watches: it is all set here.",
          },
        },
        map: {
          country: {
            title: "The map",
            body: "Click a country to see its projects.",
          },
          country_mobile: {
            title: "The map",
            body: "Tap a country to see its projects.",
          },
        },
      },
      menu: {
        replay: "Replay the tour",
        tips: "Show screen tips again",
        tips_reset: "Tips will show again on each screen",
        tips_error: "Tips could not be reset",
      },
      label: "Aubeon tour",
      skip: "Skip",
      next: "Next",
      previous: "Back",
      example: "Example",
      paused: "Paused",
      pause: "Pause",
      resume: "Resume",
      units: { millions: "%{amount}M %{currency}" },
      stamp: { extracted: "Sourced", inferred: "Inferred" },
      fields: {
        structure_type: "Structure",
        budget_amount: "Amount",
        start_date: "Start",
        phase: "Phase",
        city: "City",
      },
      scene: {
        "1": {
          of: "1 of 6",
          title: "Major concrete projects, spotted before anyone else.",
          kicker: "Worldwide watch",
          projects: "projects tracked",
          sources: "sources read every night",
          countries: "countries covered",
          lead: "Every night, Aubeon reads tenders, council decisions, permits and the press worldwide.",
        },
        "2": {
          of: "2 of 6",
          title: "A notice becomes a project file.",
          kicker: "Spotted early, proven",
          sources: {
            notice: "Tender notice",
            deliberation: "Council decision",
            permit: "Permit",
            press: "Press",
          },
          lead: "%{extracted} values quoted word for word from their document, %{inferred} inferred and flagged as such.",
        },
        "3": {
          of: "3 of 6",
          title: "A score, criterion by criterion.",
          kicker: "Qualified for ETT",
          ring: "Score %{score} out of 100",
        },
        "4": {
          of: "4 of 6",
          title: "The decision chain, not just a name.",
          kicker: "Who decides",
          lead: "Owner, engineering firm, contractor: each with its part in the decision.",
          lead_invited: "Names and contacts for each link are for subscribers.",
          hidden: "Name for subscribers",
          unknown: "To be found",
          groups: {
            owner: "Owner",
            design: "Engineering firm",
            contractor: "Contractor",
          },
          filler: {
            owner: "Northern Water Board",
            design: "Atlas Engineering",
            contractor: "United Builders",
          },
        },
        "5": {
          of: "5 of 6",
          title: "Your daily 10, and an alert as soon as a project moves.",
          kicker: "Every morning",
          lead: "Every night, the radar picks the projects that moved for you.",
          project: "Project",
          no_score: "—",
        },
        "6": {
          of: "6 of 6",
          title: "Your turn.",
          kicker: "Your turn",
          title_invited: "Choose your area.",
          zone: "Your area of interest",
          zone_placeholder: "Pick a zone or a country",
          zones: "Zones",
          countries: "Countries",
          error: "The area could not be saved",
          saved: "Area saved",
          offer: "See plans",
          daily: "Open my daily 10",
          explore: "Explore",
        },
      },
    },
    companies: {
      name: "Company |||| Companies",
      forcedCaseName: "Company",
      fields: {
        name: "Company name",
        website: "Website",
        linkedin_url: "LinkedIn URL",
        phone_number: "Phone number",
        created_at: "Created at",
        nb_contacts: "Number of contacts",
        revenue: "Revenue",
        sector: "Sector",
        size: "Size",
        tax_identifier: "Tax Identifier",
        address: "Address",
        city: "City",
        zipcode: "Zip code",
        state_abbr: "State",
        country: "Country",
        description: "Description",
        context_links: "Context links",
        sales_id: "Account manager",
      },
      empty: {
        description: "It seems your company list is empty.",
        title: "No companies found",
      },
      import: {
        title: "Import companies",
      },
      field_categories: {
        contact: "Contact",
        additional_info: "Additional information",
        address: "Address",
        context: "Context",
      },
      action: {
        create: "Create Company",
        edit: "Edit company",
        new: "New Company",
        show: "Show company",
      },
      added_on: "Added on %{date}",
      followed_by: "Followed by %{name}",
      followed_by_you: "Followed by you",
      no_contacts: "No contact",
      nb_contacts: "%{smart_count} contact |||| %{smart_count} contacts",
      nb_deals: "%{smart_count} deal |||| %{smart_count} deals",
      sizes: {
        one_employee: "1 employee",
        two_to_nine_employees: "2-9 employees",
        ten_to_forty_nine_employees: "10-49 employees",
        fifty_to_two_hundred_forty_nine_employees: "50-249 employees",
        two_hundred_fifty_or_more_employees: "250 or more employees",
      },
      autocomplete: {
        create_error: "An error occurred while creating the company",
        create_item: "Create %{item}",
        create_label: "Start typing to create a new company",
      },
    },
    contacts: {
      name: "Contact |||| Contacts",
      forcedCaseName: "Contact",
      field_categories: {
        background_info: "Background info",
        identity: "Identity",
        misc: "Misc",
        personal_info: "Personal info",
        position: "Position",
      },
      fields: {
        first_name: "First name",
        last_name: "Last name",
        last_seen: "Last seen",
        title: "Title",
        company_id: "Company",
        email_jsonb: "Email addresses",
        email: "Email",
        phone_jsonb: "Phone numbers",
        phone_number: "Phone number",
        linkedin_url: "LinkedIn URL",
        background: "Background info (bio, how you met, etc)",
        has_newsletter: "Has newsletter",
        sales_id: "Account manager",
      },
      action: {
        add: "Add contact",
        add_first: "Add your first contact",
        create: "Create contact",
        edit: "Edit contact",
        export_vcard: "Export to vCard",
        new: "New Contact",
        show: "Show contact",
      },
      background: {
        last_activity_on: "Last activity on %{date}",
        added_on: "Added on %{date}",
        followed_by: "Followed by %{name}",
        followed_by_you: "Followed by you",
        status_none: "None",
      },
      position_at: "%{title} at",
      position_at_company: "%{title} at %{company}",
      empty: {
        description: "It seems your contact list is empty.",
        title: "No contacts found",
      },
      import: {
        title: "Import contacts",
      },
      inputs: {
        genders: {
          male: "He/Him",
          female: "She/Her",
          nonbinary: "They/Them",
        },
        personal_info_types: {
          work: "Work",
          home: "Home",
          other: "Other",
        },
      },
      list: {
        error_loading: "Error loading contacts",
      },
      bulk_tag: {
        action: "Tag",
        back: "Back to tags",
        create_description:
          "Create a new tag and apply it to the selected contacts.",
        description:
          "Choose an existing tag or create a new one for the selected contacts.",
        empty: "No tags yet. Create one to tag the selected contacts.",
        error: "Failed to add tag to contacts",
        noop: "Selected contacts already have this tag",
        success:
          "Tag added to %{smart_count} contact |||| Tag added to %{smart_count} contacts",
        title: "Add tag to contacts",
      },
      merge: {
        action: "Merge with another contact",
        confirm: "Merge Contacts",
        current_contact: "Current Contact (will be deleted)",
        description: "Merge this contact with another one.",
        error: "Failed to merge contacts",
        merging: "Merging...",
        no_additional_data: "No additional data to merge",
        select_target: "Please select a contact to merge with",
        success: "Contacts merged successfully",
        target_contact: "Target Contact (will be kept)",
        title: "Merge Contact",
        warning_description:
          "All data will be transferred to the second contact. This action cannot be undone.",
        warning_title: "Warning: Destructive Operation",
        what_will_be_merged: "What will be merged:",
      },
      filters: {
        before_last_month: "Before last month",
        before_this_month: "Before this month",
        before_this_week: "Before this week",
        managed_by_me: "Managed by me",
        search: "Search name, company...",
        this_week: "This week",
        today: "Today",
        tags: "Tags",
        tasks: "Tasks",
      },
      hot: {
        empty_change_status:
          'Change the status of a contact by adding a note to that contact and clicking on "show options".',
        empty_hint: 'Contacts with a "hot" status will appear here.',
        title: "Hot Contacts",
      },
    },
    deals: {
      name: "Deal |||| Deals",
      fields: {
        name: "Name",
        description: "Description",
        company_id: "Company",
        contact_ids: "Contacts",
        category: "Category",
        amount: "Budget",
        expected_closing_date: "Expected closing date",
        stage: "Stage",
        next_action: "Next action",
        next_action_type: "Next action type",
        next_action_date: "Next action date",
        project_id: "Project",
      },
      action: {
        back_to_deal: "Back to deal",
        create: "Create deal",
        new: "New Deal",
      },
      field_categories: {
        misc: "Misc",
      },
      filters: {
        only_mine: "Only deals I manage",
      },
      archived: {
        action: "Archive",
        error: "Error: deal not archived",
        list_title: "Archived Deals",
        success: "Deal archived",
        title: "Archived Deal",
        view: "View archived deals",
      },
      inputs: {
        linked_to: "Linked to",
      },
      unarchived: {
        action: "Send back to the board",
        error: "Error: deal not unarchived",
        success: "Deal unarchived",
      },
      updated: "Deal updated",
      org: {
        title: "My organisation",
        none: "You are not part of a partner organisation.",
        invited_only:
          "My organisation opens when you become a subscriber: you can then invite your colleagues and set your pipeline. See the plans:",
        invited_only_closed:
          "My organisation opens when you become a subscriber: you can then invite your colleagues and set your pipeline. To subscribe, contact your account manager.",
        intro_admin:
          "Invite your colleagues, who share your deals, contacts and credits, and set the pipeline of your own deals. Deals handed over to you keep their original stages.",
        intro_member:
          "Your colleagues share deals, contacts and credits with you. Only an organisation administrator invites members and sets the pipeline.",
        name: "Organisation name",
        saved: "Saved",
        members: "Members",
        seats: "%{active} of %{limit} seats",
        full_hint:
          "Your organisation has %{limit} active members, the maximum. Suspend a member to invite or reactivate a colleague.",
        full_error:
          "Your organisation is full: suspend a member to invite or reactivate a colleague.",
        admin: "Administrator",
        disabled: "Suspended",
        make_admin: "Make administrator",
        remove_admin: "Remove administration",
        disable: "Suspend",
        enable: "Reactivate",
        invite: "Invite a colleague",
        invite_hint:
          "They receive an e-mail to choose their password, with the same offer and territories as the organisation.",
        send_invite: "Send invitation",
        invited: "Invitation sent to %{email}",
        pipeline: "Organisation pipeline",
        pipeline_hint:
          "Stages of your own deals, in order. Tick “end” for stages that close a deal (no more overdue action). A stage used by a deal cannot be removed.",
        stage_name: "Stage name",
        closed: "end",
        up: "Move up",
        down: "Move down",
        remove_stage: "Remove stage",
        stage_count: "%{smart_count} deal |||| %{smart_count} deals",
        stage_used:
          "%{smart_count} deal in this stage: move it to another stage before removing the stage. |||| %{smart_count} deals in this stage: move them to another stage before removing the stage.",
        add_stage: "Add a stage",
        settings_hint: "Set your organisation's pipeline",
        tab_mine: "My deals",
        tab_transmitted: "Handed over",
        hosts_label: "Handing-over organisation",
        host_overdue: "An action is overdue",
        tab_todo: "To do",
        todo_empty: "No next action planned.",
      },
      invited: {
        banner:
          "Run the sales follow-up of these deals. With a subscription, you move them from stage to stage, date your next actions with reminders, create your own deals in your territory and search for contacts.",
        offers: "See the offers",
        intro:
          "Deals your partners have passed on to you. You see their stage and comment on them: each note notifies the organisation that passed it on.",
        stage: "Stage",
        last_note: "Last note",
        no_note: "No note",
        add_note: "Add a note",
        open_project: "Open the project",
        empty: "No deal has been passed on to you yet.",
      },
      board: {
        collapse: "Collapse the “%{stage}” column (for you only)",
        expand: "Expand the “%{stage}” column",
        settings: "Set up the pipeline",
        settings_hint:
          "Stages, closing stages and categories: shared by the whole team, set by an administrator",
      },
      map: {
        view_board: "Board",
        view_list: "List",
        label: "Deals map",
        loading: "Loading deals…",
        placed:
          "%{smart_count} deal on the map |||| %{smart_count} deals on the map",
        late: "%{smart_count} overdue",
        unplaced:
          "%{smart_count} deal without a placed city, not on the map |||| %{smart_count} deals without a placed city, not on the map",
        same_place:
          "%{smart_count} deal at this place |||| %{smart_count} deals at this place",
        empty: "No deal is linked to a project whose city is placed.",
      },
      suggestions: {
        title: "The radar suggests",
        take: "Take",
        dismiss: "Dismiss",
        reason_phase: "the project moved to tender",
        reason_company: "%{company} arrived (%{role})",
        reason_replied: "reply received more than 14 days ago, no follow-up",
      },
      linkedin_message: {
        copy: "Copy the LinkedIn message",
        hint: "To send if the person accepted your connection request",
      },
      next_action_types: {
        follow_up: "Follow up",
        call: "Call",
        send_documentation: "Send documentation",
        propose_meeting: "Propose a meeting",
        present: "Present to the design office",
        site_visit: "Site visit",
        check_cctp: "Check the specification",
        contact_contractor: "Contact the contractor",
        linkedin_dm: "Send the first LinkedIn message",
        other: "Other",
      },
      due: {
        tomorrow: "Tomorrow",
        in3: "In 3 days",
        monday: "Monday",
        in2weeks: "In 2 weeks",
      },
      journal: {
        title: "Log",
        empty: "No exchange logged.",
        log: "Log an exchange",
        kind: "Type",
        person: "Person",
        company: "The company",
        direction_out: "Sent",
        direction_in: "Received",
        note: "Note (optional, 500 characters)",
        save: "Log",
        saved: "Exchange logged",
        kinds: {
          email: "Email",
          linkedin: "LinkedIn",
          call: "Call",
          meeting: "Meeting",
          site_visit: "Visit",
          documentation: "Documentation",
        },
        reply: {
          pending: "Pending",
          replied: "Replied",
          no_reply: "No reply",
          declined: "Declined",
        },
        follow_up_offer: "Follow up with %{name} on %{date}?",
        follow_up_company: "Follow up with the company on %{date}?",
        accept: "Yes",
        later: "Later",
        stage_offer: "First message sent: move the deal to “%{stage}”?",
        stage_move: "Move",
      },
      my_day: {
        title: "My day",
        empty: "Nothing urgent today.",
        error: "Your day could not be loaded.",
        overdue: "Overdue",
        today: "Today",
        replies: "Replies to handle",
        no_action: "No next step",
        replied: "%{name} replied",
        replied_company: "Reply received",
      },
      pilot: {
        menu: "Pipeline review",
        loading: "Loading the figures…",
        error: "The pipeline review could not be loaded.",
        title: "Pipeline review",
        intro_all: "The whole team.",
        intro_mine: "Your figures.",
        activity: "Exchanges sent per week",
        reply_rates: "Reply rate (90 days, messages older than 7 days)",
        without_action: "Deals without a next action",
        overdue: "Overdue actions",
        stuck: "Deals at the same stage for more than 30 days",
        stuck_since: "Stages tracked since %{date}",
        stuck_since_none:
          "No stage change recorded yet: deals count from their creation.",
        conversion: "Moving from one stage to the next",
        conversion_line: "%{reached} of %{entered}",
        prescriptions: "Specifications won per quarter",
        created: "Deals created per month",
        none: "No data yet.",
      },
      next_action_editor: {
        set: "Plan an action",
        change: "Change",
        type: "Action",
        note: "Note (optional)",
        note_required: "A note is required for “Other”",
        other_day: "Another day",
        done: "Done",
        saved: "Next action saved",
        none: "No next action",
        filter_none: "No next action",
        follow_up_person: "Follow up with %{name}",
      },
      follow_up: {
        title: "Sales follow-up",
        follow: "Follow this project",
        help: "Create the deal for this project to track its stage, next action and exchanges.",
        open_deal: "Open deal",
        open_project: "Open project",
        no_action: "No action planned",
        overdue: "Overdue",
        partners_following:
          "A partner is also following this project on their side: %{names} |||| Partners are also following this project on their side: %{names}",
        empty_list:
          "No open deal. Open a project and tap “Follow this project”.",
      },
      empty: {
        before_create: "before creating a deal.",
        description: "It seems your deal list is empty.",
        title: "No deals found",
      },
      import: {
        title: "Import deals",
      },
      invalid_date: "Invalid date",
    },
    notes: {
      name: "Note |||| Notes",
      forcedCaseName: "Note",
      fields: {
        status: "Status",
        date: "Date",
        attachments: "Attachments",
        contact_id: "Contact",
        deal_id: "Deal",
      },
      action: {
        add: "Add note",
        add_first: "Add your first note",
        delete: "Delete note",
        edit: "Edit note",
        update: "Update note",
        add_this: "Add this note",
      },
      sheet: {
        create: "Create note",
        create_for: "Create note for %{name}",
        edit: "Edit note",
        edit_for: "Edit note for %{name}",
      },
      deleted: "Note deleted",
      empty: "No notes yet",
      author_added: "%{name} added a note",
      you_added: "You added a note",
      me: "Me",
      list: {
        error_loading: "Error loading notes",
      },
      note_for_contact: "Note for %{name}",
      stepper: {
        hint: "Go to a contact page and add a note",
      },
      added: "Note added",
      inputs: {
        add_note: "Add a note",
        options_hint: "(attach files, or change details)",
        show_options: "Show options",
      },
      actions: {
        attach_document: "Attach document",
      },
      validation: {
        note_or_attachment_required: "A note or an attachment is required",
      },
    },
    sales: {
      name: "Team member |||| Team members",
      intro:
        "The people of your company: they see the whole database and your deals. For a distributor or an installer, use Partners.",
      fields: {
        first_name: "First name",
        last_name: "Last name",
        email: "Email",
        secondary_email: "Secondary email",
        secondary_emails: "Secondary emails",
        administrator: "Admin",
        disabled: "Disabled",
      },
      create: {
        error: "An error occurred while adding the team member.",
        success:
          "Team member added: they will soon receive an email to choose their password.",
        title: "Add a team member",
      },
      edit: {
        error: "An error occurred. Please try again.",
        record_not_found: "Record not found",
        success: "Team member updated",
        title: "Edit %{name}",
      },
      action: {
        new: "New team member",
      },
    },
    tasks: {
      name: "Task |||| Tasks",
      forcedCaseName: "Task",
      fields: {
        text: "Description",
        due_date: "Due date",
        type: "Type",
        contact_id: "Contact",
        due_short: "due",
      },
      action: {
        add: "Add task",
        create: "Create task",
        edit: "Edit task",
      },
      actions: {
        postpone_next_week: "Postpone to next week",
        postpone_tomorrow: "Postpone to tomorrow",
        title: "task actions",
      },
      added: "Task added",
      deleted: "Task deleted successfully",
      dialog: {
        create: "Create task",
        create_for: "Create task for %{name}",
      },
      sheet: {
        edit: "Edit task",
        edit_for: "Edit task for %{name}",
      },
      empty: "No tasks yet",
      empty_list_hint: "Tasks added to your contacts will appear here.",
      filters: {
        later: "Later",
        overdue: "Overdue",
        this_week: "This week",
        today: "Today",
        tomorrow: "Tomorrow",
        with_pending: "With pending tasks",
      },
      regarding_contact: "(Re: %{name})",
      updated: "Task updated",
    },
    tags: {
      name: "Tag |||| Tags",
      action: {
        add: "Add tag",
        create: "Create new tag",
      },
      dialog: {
        color: "Color",
        create_title: "Create a new tag",
        edit_title: "Edit tag",
        name_label: "Tag name",
        name_placeholder: "Enter tag name",
      },
      empty: "No tags yet.",
    },
  },
  crm: {
    action: {
      reset_password: "Reset Password",
    },
    auth: {
      first_name: "First name",
      last_name: "Last name",
      confirm_password: "Confirm password",
      confirmation_required:
        "Please follow the link we just sent you by email to confirm your account.",
      recovery_email_sent:
        "If you're a registered user, you should receive a password recovery email shortly.",
      sign_in_failed: "Failed to log in.",
      code: {
        send: "Get a code by e-mail",
        sent: "If this address has an account, a code has just been sent to it.",
        help: "Enter the six-digit code sent to %{email}. Check your spam folder too.",
        label: "Code received by e-mail",
        invalid: "Wrong or expired code. Ask for a new one.",
        too_many:
          "Too many requests: wait a minute before asking for a new code.",
        change_email: "Use another address",
        resend: "Send a new code",
        use_password: "Sign in with a password",
        use_code: "Sign in with a code sent by e-mail",
      },
      sign_in_google_workspace: "Sign in with Google Workplace",
      signup: {
        create_account: "Create account",
        create_first_user:
          "Create the first user account to complete the setup.",
        creating: "Creating...",
        initial_user_created: "Initial user successfully created",
      },
      welcome_title: "Welcome to Aubeon",
    },
    common: {
      account_manager: "Account manager",
      activity: "Activity",
      added: "added",
      details: "Details",
      last_activity_with_date: "last activity %{date}",
      load_more: "Load more",
      misc: "Misc",
      past: "Past",
      read_more: "Read more",
      retry: "Retry",
      show_less: "Show less",
      copied: "Copied!",
      copy: "Copy",
      loading: "Loading...",
      me: "Me",
      task_count: "%{smart_count} task |||| %{smart_count} tasks",
    },
    changelog: {
      title: "Changelog",
    },
    activity: {
      added_company: "%{name} added company",
      you_added_company: "You added company",
      added_contact: "%{name} added",
      you_added_contact: "You added",
      added_note: "%{name} added a note about",
      you_added_note: "You added a note about",
      added_note_about_deal: "%{name} added a note about deal",
      you_added_note_about_deal: "You added a note about deal",
      added_deal: "%{name} added deal",
      you_added_deal: "You added deal",
      at_company: "at",
      to: "to",
      load_more: "Load more activity",
    },
    dashboard: {
      deals_chart: "Upcoming Deal Revenue",
      deals_pipeline: "Deals Pipeline",
      latest_activity: "Latest Activity",
      latest_activity_error: "Error loading latest activity",
      latest_notes: "My Latest Notes",
      latest_notes_added_ago: "added %{timeAgo}",
      stepper: {
        install: "Install Aubeon",
        progress: "%{step}/3 done",
        whats_next: "What's next?",
      },
      upcoming_tasks: "Upcoming Tasks",
    },
    data_import: {
      button: "Import CSV",
      complete:
        "Import complete. Imported %{importCount} records, with %{errorCount} errors",
      csv_file: "CSV File",
      error:
        "Failed to import this file, please make sure you provided a valid CSV file.",
      in_progress: "Import in progress…",
      progress:
        "Imported %{importCount} / %{rowCount} records, with %{errorCount} errors.",
      remaining_time: "Estimated remaining time:",
      resource: "Resource",
      sample_download: "Download CSV sample",
      sample_hint: "Here is a sample CSV file you can use as a template",
      start: "Start import",
      stop: "Stop import",
      stopped:
        "Import stopped. Imported %{importCount} records, with %{errorCount} errors",
      title: "Import data",
    },
    header: {
      import_data: "Import from JSON",
    },
    image_editor: {
      change: "Change",
      drop_hint: "Drop a file to upload, or click to select it.",
      editable_content: "Editable content",
      title: "Upload and resize image",
      update_image: "Update Image",
    },
    import: {
      action: {
        download_error_report: "Download the error report",
        import: "Import",
        import_another: "Import another file",
      },
      error: {
        unable: "Unable to import this file.",
      },
      idle: {
        description_1:
          "You can import sales, companies, contacts, companies, notes, and tasks.",
        description_2:
          "Data must be in a JSON file matching the following sample:",
      },
      status: {
        all_success: "All records were imported successfully.",
        complete: "Import complete.",
        failed: "Failed",
        imported: "Imported",
        in_progress:
          "Import in progress, please don't navigate away from this page.",
        some_failed: "Some records were not imported.",
        table_caption: "Import status",
      },
      title: "Import from JSON",
    },
    settings: {
      about: "About",
      companies: {
        sectors: "Sectors",
      },
      dark_mode_logo: "Dark Mode Logo",
      deals: {
        categories: "Categories",
        currency: "Currency",
        pipeline_help:
          "Select which deal stages should count as pipeline deals.",
        pipeline_statuses: "Pipeline Statuses",
        closed_stages: "Closing stages",
        closed_stages_help:
          "A deal that reaches one of these stages is finished: it is no longer counted among the open deals of the dashboard, no longer shown on the map and no longer raises an overdue action alert. Select any stage you add to close a deal (for example “Abandoned”). A stage you have just added can be selected once saved.",
        stages: "Stages",
        stage_counts:
          "Deals per stage: %{items}. A stage in use cannot be removed: first move its deals to another stage.",
        admin_only:
          "These settings apply to your whole team and to the partners you hand a deal to. Only an administrator can change them: everyone must see the same stages, and the dashboard, the map and the alerts must count deals the same way for everyone. To lighten their own screen, anyone can collapse the columns they do not use from the Deals screen, without changing anything for others.",
      },
      light_mode_logo: "Light Mode Logo",
      notes: {
        statuses: "Statuses",
      },
      reset_defaults: "Reset to Defaults",
      save_error: "Failed to save configuration",
      saved: "Configuration saved successfully",
      saving: "Saving...",
      tasks: {
        types: "Types",
      },
      preferences: "Preferences",
      title: "Settings",
      app_title: "App Title",
      sections: {
        branding: "Branding",
      },
      validation: {
        duplicate: "Duplicate %{display_name}: %{items}",
        in_use:
          "Cannot remove %{display_name} that are still used by deals: %{items}",
        stages_in_use:
          "Stage still used by deals: %{items}. Move them to another stage before removing the stage.",
        validating: "Validating\u2026",
        entities: {
          categories: "categories",
          stages: "stages",
        },
      },
    },
    theme: {
      dark: "Dark",
      label: "Theme",
      light: "Light",
      system: "System",
    },
    language: "Language",
    currency: "Currency",
    navigation: {
      home: "Home",
      account_install: "Settings: app to install",
      label: "CRM navigation",
      radar: "Radar",
    },
    profile: {
      add_secondary_email: "Add an email",
      email_taken: "%{email} is already used by another user",
      no_secondary_emails: "None",
      secondary_email_invalid: "%{email} is not a valid email address",
      secondary_email_is_primary: "%{email} is already your main address",
      secondary_email_taken: "%{email} is already used by another user",
      too_many_secondary_emails:
        "You cannot add more than 10 secondary email addresses",
      secondary_emails_help:
        "Other addresses you send emails from. Leave one empty to remove it.",
      inbound: {
        description:
          "You can start sending emails to your server's inbound email address, e.g. by adding it to the %{field} field. Aubeon will process the emails and add notes to the corresponding contacts.",
        title: "Inbound email",
      },
      mcp: {
        title: "MCP Server",
        description:
          "Use this URL to connect your AI assistant to your CRM data via the Model Context Protocol (MCP).",
      },
      password: {
        change: "Change password",
      },
      password_reset_sent:
        "A reset password email has been sent to your email address",
      record_not_found: "Record not found",
      title: "Profile",
      updated: "Your profile has been updated",
      update_error: "An error occurred. Please try again",
    },
    validation: {
      invalid_url: "Must be a valid URL",
      invalid_linkedin_url: "URL must be from linkedin.com",
    },
  },
} as const;

type MessageSchema<T> = {
  [K in keyof T]: T[K] extends string
    ? string
    : T[K] extends Record<string, unknown>
      ? MessageSchema<T[K]>
      : never;
};

type DeepPartial<T> = {
  [K in keyof T]?: T[K] extends Record<string, unknown>
    ? DeepPartial<T[K]>
    : T[K];
};

export type CrmMessages = MessageSchema<typeof englishCrmMessages>;
export type PartialCrmMessages = DeepPartial<CrmMessages>;
